module.exports = __webpack_public_path__ + "img/user04.3ae9aba4.jpg";